import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  DnaReportQueriesFindAllArgs,
  DnaReportQueryResult,
  Query
} from '@interfaces/schema';

/**
 * DeeplinksService.
 *
 * @exports
 * @class DeeplinksService
 */
@Injectable()
export class DeeplinksService {
  private readonly apollo = inject(Apollo);

  /**
   * Get dna report.
   *
   * @param {DnaReportQueriesFindAllArgs} [variables] Params.
   * @returns {Observable<DnaReportQueryResult>}
   * @memberof DeeplinksService
   */
  fetchDNAReports(
    variables?: DnaReportQueriesFindAllArgs
  ): Observable<DnaReportQueryResult> {
    const query = gql`
      query findAllDNAReport($where: DNAReportQueryFilter, $limit: Int) {
        DNA {
          Report {
            findAll(where: $where, limit: $limit) {
              results {
                id
                reportType
                agreeDisclaimerAt
                profileId
                releasedAt
              }
            }
          }
        }
      }
    `;
    return this.apollo
      .query<Query>({ query, variables })
      .pipe(
        map(
          ({ data }) => get(data, 'DNA.Report.findAll') as DnaReportQueryResult
        )
      );
  }
}
